import { map } from 'lodash';

export default function CustomField({ answer, setAnswer, field }) {
    let placeholder = field.question + (field.is_required ? ' *' : ' (optional)');

    const spacingClass = 'w-full';
    const spacingClasses = {
        1: 'w-1/12',
        2: 'w-2/12',
        3: 'w-3/12',
        4: 'w-4/12',
        5: 'w-5/12',
        6: 'w-6/12',
        7: 'w-7/12',
        8: 'w-8/12',
        9: 'w-9/12',
        10: 'w-10/12',
        11: 'w-11/12',
        12: 'w-full',
    };
    if (field.spacing) {
        spacingClass = spacingClasses[field.spacing] + ' pr-1';
    }
    const labelView = (field.show_label) && <label className="font-bold text-sm">{field.label}</label>;
    if (field.type === 'text_area') {
        return (
            <div className={`mb-3 ${spacingClass}`}>
              {labelView}
              <textarea
                className="rg-textarea w-full"
                type={field.type}
                placeholder={placeholder}
                value={answer}
                required={field.is_required}
                onChange={event => setAnswer(event.target.value)}
                autoComplete={field.autocomplete || field.id} >
              </textarea>
            </div>
        );
    } else if (field.type === 'checkbox') {
        return (
            <div className={`my-2 ${spacingClass} flex flex-row items-center justify-center`}>
              {labelView}
              <input
                id={field.id}
                type="checkbox"
                className="m-2"
                type={field.type}
                required={field.is_required}
                placeholder={placeholder}
                checked={answer}
                onChange={event => setAnswer(event.target.checked)}
                autoComplete={field.autocomplete || field.id} />
              <label for={field.id} className="flex-1 cursor-pointer input-label"
                     dangerouslySetInnerHTML={{__html: (field.label || field.question || '') + (field.is_required ? ' *' : '')}}
              ></label>
            </div>
        );
    } else if (field.type === 'select') {
        return (
            <div className={`mb-3 ${spacingClass}`}>
              <div>
                <label className="font-bold text-sm">{field.question}
                  <span className="pl-1">{field.is_required ? '*' : ''}</span>
                </label>
              </div>
              <select className="rg-select" onChange={
                  event => {
                      console.log('EVENT', event.target.value);
                      setAnswer(event.target.value);
                  }
              }>
                <option value="__default">Bitte wählen</option>
                {
                    map(field.possible_answers, possibleAnswer => (
                        <option key={possibleAnswer} value={possibleAnswer}>{possibleAnswer}</option>
                    ))
                }
				      </select>
            </div>
        );
    }
    
    return (
        <div className={`mb-3 ${spacingClass}`}>
          {labelView}
          <input
            className="rg-input w-full"
            type={field.type}
            required={field.is_required}
            placeholder={placeholder}
            value={answer}
            onChange={event => setAnswer(event.target.value)}
            autoComplete={field.autocomplete || field.id} />
        </div>
    );
}

